import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

init();

function init() {
  const popups = [...document.querySelectorAll("[id^=popup]")];

  if (popups.length) {
    generatePopupStyles(popups);
    initOpenButtons();
    initCloseButtons();
    window.addEventListener(
      "load",
      () => (document.body.dataset.dialoginit = ""),
    );
  }
}

function generatePopupStyles(popups) {
  const styleTag = document.createElement("style");
  let popupStyles = popups.map((popup) => {
    popup.addEventListener("click", (event) => event.stopPropagation());

    const name = popup.id.replace("popup_", "");
    return `body[data-dialog="${name}"] #${popup.id}`;
  });
  popupStyles = popupStyles.join(",");
  popupStyles = `${popupStyles}{ visibility: visible; opacity: 1; transition: opacity 200ms; }`;
  styleTag.innerHTML = popupStyles;
  document.head.append(styleTag);
}

function initOpenButtons() {
  const openButtons = [...document.querySelectorAll("[data-popup]")];

  openButtons.forEach((openButton) => {
    openButton.addEventListener("click", (event) =>
      openPopup(event.currentTarget.dataset.popup),
    );
  });
}

function openPopup(name) {
  const popup = document.querySelector(`#popup_${name}`);
  if (popup && document.body.dataset.dialog !== name) {
    document.body.dataset.dialog = name;
    clearAllBodyScrollLocks();
    disableBodyScroll(popup);
  }
}

function initCloseButtons() {
  const closeButtons = [...document.querySelectorAll("[data-popup-close]")];

  closeButtons.forEach((closeButton) =>
    closeButton.addEventListener("click", closePopups),
  );

  document.querySelector("#overlay").addEventListener("click", closePopups);

  document.addEventListener("keydown", ({ code }) => {
    if (code === "Escape") {
      closePopups();
    }
  });
}

function closePopups() {
  delete document.body.dataset.dialog;
  clearAllBodyScrollLocks();
}

export { openPopup };
